import * as React from "react";

import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";

import { useTheme } from "@fartherfinance/frontend/theme/ThemeProvider";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => {
  const {
    color: { $icon },
  } = useTheme();

  return (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ color: $icon, width: 14 }} />}
      {...props}
    />
  );
})(({ theme }) => {
  const {
    color: { $surface, $borderBold },
  } = useTheme();
  return {
    flexDirection: "row-reverse",
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "rotate(90deg)",
    },
    "& .MuiAccordionSummary-content": {
      marginLeft: theme.spacing(1),
    },
    backgroundColor: $surface,
    borderBottom: `1px solid ${$borderBold}`,
    padding: "16px",
  };
});

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => {
  const {
    color: { $borderBold },
  } = useTheme();
  return {
    padding: theme.spacing(2),
    borderBottom: `1px solid ${$borderBold}`,
  };
});

export { Accordion, AccordionSummary, AccordionDetails };
